<template>
    <div class="step">
        <div class="flex flex-col justify-center items-start self-stretch">
            <!-- Selected program section -->
            <p
                class="text-sm font-medium text-slate-600 dark:text-slate-300 font-['Inter'] leading-5 mb-2"
            >
                Program
            </p>
            <div class="flex items-center gap-4 mb-6">
                <div
                    class="flex items-center justify-center rounded-lg border border-slate-200 dark:border-slate-700"
                    style="width: 112px; height: 48px; padding: 6px 14px"
                >
                    <img
                        v-if="chosenProgram && chosenProgram.image"
                        :src="getProgramImageUrl(chosenProgram.image)"
                        :alt="chosenProgram ? chosenProgram.name : ''"
                        class="max-w-full max-h-full object-contain"
                    />
                    <span
                        v-else
                        class="text-[10px] font-medium text-gray-500 dark:text-slate-400 text-center"
                    >
                        {{
                            chosenProgram?.name
                                ? chosenProgram.name.slice(0, 10)
                                : ''
                        }}
                    </span>
                </div>
                <span
                    class="text-sm font-medium text-slate-800 dark:text-slate-100 font-['Inter'] leading-5"
                >
                    {{ chosenProgram ? chosenProgram.name : '' }}
                </span>
            </div>

            <!-- Balance and Date inputs -->
            <div class="flex gap-4 w-full">
                <div class="flex-1">
                    <p
                        class="text-slate-600 dark:text-slate-300 text-sm font-medium font-['Inter'] leading-5 mb-2"
                    >
                        Program balance
                    </p>
                    <input
                        type="text"
                        placeholder="Program balance"
                        :value="formattedPoints"
                        @input="$emit('update:formattedPoints', $event.target.value)"
                        class="w-full py-2.5 px-4 rounded border bg-white dark:bg-slate-700 text-slate-800 dark:text-slate-100 text-sm font-normal leading-5 placeholder:text-slate-500 dark:placeholder:text-slate-400 focus:outline-none focus:border-slate-400"
                        :class="{
                            'border-slate-200 dark:border-slate-600': !hasPointsError,
                            'border-red-500': hasPointsError,
                        }"
                        @keydown="$emit('clear-error')"
                    />
                </div>
                <div class="flex-1">
                    <p
                        class="text-slate-600 dark:text-slate-300 text-sm font-medium font-['Inter'] leading-5 mb-2"
                    >
                        Date
                    </p>
                    <div class="relative w-full">
                        <div
                            class="absolute left-0 top-0 bottom-0 w-10 flex items-center justify-center border-r border-slate-200 dark:border-slate-600 pointer-events-none z-10"
                        >
                            <Icon
                                icon="calendar"
                                class="w-5 h-5 text-slate-800 dark:text-slate-300"
                            />
                        </div>
                        <flat-pickr
                            v-model="program.balance_date"
                            :config="{
                                dateFormat: 'M d, Y',
                                defaultDate: new Date(),
                            }"
                            class="w-full py-2.5 pl-12 pr-4 rounded border border-slate-200 dark:border-slate-600 bg-white dark:bg-slate-700 text-slate-800 dark:text-slate-100 text-sm font-normal leading-5 placeholder:text-slate-500 dark:placeholder:text-slate-400 focus:outline-none focus:border-slate-400 cursor-pointer"
                            placeholder="Select date"
                        />
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
import { computed } from 'vue';
import Icon from '@/components/ui/icon/icon.vue';
import flatPickr from '@/components/ui/SafeFlatPickr.vue';

const props = defineProps({
    program: { type: Object, required: true },
    chosenProgram: { type: Object, default: null },
    formattedPoints: { type: String, required: true },
    errors: { type: Array, required: true },
    getProgramImageUrl: { type: Function, required: true },
});

defineEmits(['update:formattedPoints', 'clear-error']);

const hasPointsError = computed(() => {
    return props.errors.some(
        (error) => error.message === 'Please enter your points.'
    );
});
</script>
